export function AddressLoadingSkeleton() {
  return (
    <div className='space-y-2'>
      <div className='h-5 w-3/4 animate-pulse rounded bg-muted' />
      <div className='h-5 w-1/2 animate-pulse rounded bg-muted' />
      <div className='h-5 w-2/3 animate-pulse rounded bg-muted' />
    </div>
  )
}
